var _rect, _rect2, _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDataRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3711,
    transform: "translate(-378 -583)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1245_23412)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45001 7.50001C4.45001 6.36783 5.36783 5.45001 6.50001 5.45001H17.5C18.6322 5.45001 19.55 6.36783 19.55 7.50001C19.55 8.6322 18.6322 9.55001 17.5 9.55001H6.50001C5.36783 9.55001 4.45001 8.6322 4.45001 7.50001ZM6.50001 6.55001C5.97534 6.55001 5.55001 6.97534 5.55001 7.50001C5.55001 8.02468 5.97534 8.45001 6.50001 8.45001H17.5C18.0247 8.45001 18.45 8.02468 18.45 7.50001C18.45 6.97534 18.0247 6.55001 17.5 6.55001H6.50001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45001 10.5C4.45001 9.36783 5.36783 8.45001 6.50001 8.45001H17.5C18.6322 8.45001 19.55 9.36783 19.55 10.5C19.55 11.6322 18.6322 12.55 17.5 12.55H6.50001C5.36783 12.55 4.45001 11.6322 4.45001 10.5ZM6.50001 9.55001C5.97534 9.55001 5.55001 9.97534 5.55001 10.5C5.55001 11.0247 5.97534 11.45 6.50001 11.45H17.5C18.0247 11.45 18.45 11.0247 18.45 10.5C18.45 9.97534 18.0247 9.55001 17.5 9.55001H6.50001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45001 13.5C4.45001 12.3678 5.36783 11.45 6.50001 11.45H17.5C18.6322 11.45 19.55 12.3678 19.55 13.5C19.55 14.6322 18.6322 15.55 17.5 15.55H6.50001C5.36783 15.55 4.45001 14.6322 4.45001 13.5ZM6.50001 12.55C5.97534 12.55 5.55001 12.9753 5.55001 13.5C5.55001 14.0247 5.97534 14.45 6.50001 14.45H17.5C18.0247 14.45 18.45 14.0247 18.45 13.5C18.45 12.9753 18.0247 12.55 17.5 12.55H6.50001Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45001 16.5C4.45001 15.3678 5.36783 14.45 6.50001 14.45H17.5C18.6322 14.45 19.55 15.3678 19.55 16.5C19.55 17.6322 18.6322 18.55 17.5 18.55H6.50001C5.36783 18.55 4.45001 17.6322 4.45001 16.5ZM6.50001 15.55C5.97534 15.55 5.55001 15.9753 5.55001 16.5C5.55001 17.0247 5.97534 17.45 6.50001 17.45H17.5C18.0247 17.45 18.45 17.0247 18.45 16.5C18.45 15.9753 18.0247 15.55 17.5 15.55H6.50001Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1245_23412",
    x: -31,
    y: -27,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1245_23412"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1245_23412",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDataRound);
export default __webpack_public_path__ + "static/media/ic-data-round.24b57ce8f37809c7e4199a5d0bf214b9.svg";
export { ForwardRef as ReactComponent };